const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the user overview component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('presentationVideo', [function() {
  return {
    scope: {
      cancel: '&',
      add: '&',
      presentation: '='
    },
    template: require('../../templates/directives/presentation-video.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.video = {};
      self.resetAdd = false;
      self.addVideo = function(upload) {
        $scope.add({video: self.video});
        if (upload) {
          return;
        }
        self.video = {};
        self.resetAdd = true;
      };
      self.cancelVideo = function() {
        self.video = {};
        $scope.cancel();
        self.resetAdd = true;
      };
      $scope.$watch('presentationVideo.video', function(newVal, oldVal) {
        if (newVal.transcoding && !oldVal.transcoding) {
          self.addVideo(true);
        }
      }, true);
    }],
    controllerAs: 'presentationVideo'
  }
}]);